import React, { createContext, useContext } from 'react';
import { defaultConfig } from '@medely/base';
import { ConfigurationProviderProps } from './interface';

/**
 * This context provider makes it possible to access configuration values in hooks in our component
 * library, and to enforce a more consistent configuration object across our client apps
 */
const ConfigurationContext = createContext(defaultConfig);

const ConfigurationProvider = ({ children, configuration }: ConfigurationProviderProps) => (
  <ConfigurationContext.Provider value={Object.assign(defaultConfig, configuration)}>
    {children}
  </ConfigurationContext.Provider>
);

const useConfigurationContext = () => useContext(ConfigurationContext);

export { ConfigurationContext, ConfigurationProvider, useConfigurationContext };
